module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-no"
  }, [_vm._v("TABLE OF CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "ch-line"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm02"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 1")]), _vm._v(" Crazy Woman and a Scotch, Please")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 2")]), _vm._v(" One Second and Just a Few Inches Make a Difference")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 3")]), _vm._v(" Magic Mail and Diamonds")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 4")]), _vm._v(" A Perfect Storm and a Trip to Paradise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 5")]), _vm._v(" Sit Back and Relax")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 6")]), _vm._v(" A Jammy Piece and an Overhead Contraption")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 7")]), _vm._v(" The Elevator Shaft and a Love Affair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 8")]), _vm._v(" Stinging Cheeks and Gratitude")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 9")]), _vm._v(" Plum Brandy and a Tummy Bug")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 10")]), _vm._v(" Poppy Fields and The Ice Machine Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 11")]), _vm._v(" Speckle’s Demise and Mushroom Pixies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 12")]), _vm._v(" Candy and Excited Grunting Pigs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 13")]), _vm._v(" Survival 101 and Crispy Skin Strips")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 14")]), _vm._v(" A Cornfield and a Whole Lot of Grit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 15")]), _vm._v(" Lip Gloss and a Room with a View")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 16")]), _vm._v(" A Fireball of Anger and a Glimmer of Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 17")]), _vm._v(" A Mountain of Food and a Needle in a Haystack")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 18")]), _vm._v(" Goosebumps and Living the Good Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 19")]), _vm._v(" A Slow Unraveling and Never Say Never")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 20")]), _vm._v(" Heading West and Finding Shangri-la")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 72
// module chunks = 0